import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { Container, Typography } from '@mui/material';
// components
import { MotionContainer, varBounce } from '../components/animate';
// assets
import { ForbiddenIllustration } from '../assets/illustrations';
//
import { useAuthContext } from './useAuthContext';

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  roles: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  hasContent: PropTypes.bool,
  children: PropTypes.node,
};

export default function RoleBasedGuard({ roles = [], hasContent = false, children }) {
  // Logic here to get current user role
  const { user } = useAuthContext();

  if (!user) {
    // Kamu bisa return loader atau null
    return null;
  }

  // const currentRole = 'user';
  const currentRole =
    typeof user.role === 'object'
      ? user.role?.name || user.role?.id?.toString()
      : user.role?.toString();

  const roleId = user.role_id?.toString();
  const allowed =
    !roles.length ||
    roles.some(
      (role) =>
        role === currentRole ||
        role === roleId ||
        role === user.role?.id ||
        role === user.role?.name
    );

  // 🚫 If user is not allowed
  if (!allowed) {
    if (hasContent) {
      return (
        <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" paragraph>
              Permission Denied
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              You do not have permission to access this page.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <ForbiddenIllustration sx={{ height: 260, my: { xs: 5, sm: 10 } }} />
          </m.div>
        </Container>
      );
    }

    // 🔒 Element-level: just hide
    return null;
  }

  // ✅ Authorized
  return <>{children}</>;
}
